<template>

    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.grupo"
                    defaultOptionText="Todos"
                    label="Grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.solicitacao.exame"
                    :requestQueryStringParams="requestQueryStringParams"
                    :searchFields="fields.autocompleteExame.exame"
                    :text-field="i => i.codigo ? `${this.formatProcedimento(i.codigo)} - ${i.nome}` : i.nome"
                    :validations="validations.exame"
                    label="Exame"
                    placeholder="Digite o código ou o nome do exame"
                    uppercase
                    v-model="model.exame"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(handleAdd)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository, error, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

import origem from '@/enums/regulacao/origem'

export default {
    computed: {
        requestQueryStringParams() {

            let examesAdicionadosIds = this.examesAdicionadosIds;

            const object = {
                infraestrutura_solicitante_id: this.infraestruturaSolicitanteId,
                not_id: examesAdicionadosIds,
                regulador_id: this.reguladorId,
                sexo_paciente: this.sexoPaciente,
            }

            if (this.model.grupoId) {

                object.grupo_id = this.model.grupoId;
            }

            if (this.examesModal.length > 0 && (this.model?.exame?.regulacaoTipoId || this.examesModal[0]?.regulacaoTipoId)) {

                object.regulacao_tipo_id = this.model?.exame?.regulacaoTipoId || this.examesModal[0]?.regulacaoTipoId;
            }

            return object;
        },
        fields() {

            return {
                autocompleteExame: {
                     exame: [
                        { key: 'exame.codigo', searchable: true },
                        { key: 'exame.nome', searchable: true },
                     ]
                },
            }
        },
        validations() {

            return {
                exame: { required: true },
            }
        },
        examesAdicionadosIds() {

            if (this.isEdicao) {

                return this.examesModal.map(e => e.exameId)
            }

            return this.examesModal.map(e => e.id)
        }
    },
    created() {
        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }

        this.load();
    },
    data: () => ({
        model: {
            exame: null,
            exames: [],
            grupoId: null,
        },
        form: {
            grupo: [],
        },
        enums: {
            origem,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading();

            this.repositories.solicitacao.list({
                infraestrutura_solicitante_id: this.infraestruturaSolicitanteId,
                listar: 'grupos-exames',
                regulador_id: this.reguladorId
            })
            .then(response => {
                this.form.grupo = response.data;
            })
            .catch(this.handleError)
            .finally(this.unsetLoading);
        },
        handleAdd() {

            if (this.model.exame.tipoId !== this.enums.origem.EXAME_LABORATORIAL) {

                this.add()

                return
            }

            this.setLoading()

            this.repositories.solicitacao.getAgendamentoExameNoPrazoDeValidade(this.pacienteId, this.model.exame.id)
                .then(({ data }) => {

                    this.add(data)
                })
                .catch(this.handleError)
                .finally(this.unsetLoading)
        },
        add(agendamentosNaValidade = []) {

            const solicitacoesItens = this.solicitacoesItens.concat(agendamentosNaValidade)

            let exameAtual = this.model.exame;

            if (this.isEdicao) {

                const { id: exameId, ...resto } = exameAtual;
                exameAtual = { exameId, ...resto };
            }

            const temExameImagem = this.examesModal.some(exame => exame.tipoId === this.enums.origem.EXAME_IMAGEM);
            const temExameLaboratorial = this.examesModal.some(exame => exame.tipoId === this.enums.origem.EXAME_LABORATORIAL);

            if (exameAtual.tipoId === this.enums.origem.EXAME_IMAGEM) {

                if (temExameImagem) {

                    this.showWarningNotification(
                        'Só é permitido um exame de imagem por solicitação.'
                    );

                    this.model.exame = null;
                    return;
                }
                if (temExameLaboratorial) {

                    this.showWarningNotification(
                        'Não é permitido adicionar exames de imagem em uma mesma solicitação de exames laboratoriais.'
                    );

                    this.model.exame = null;
                    return;
                }
            } else if (exameAtual.tipoId === this.enums.origem.EXAME_LABORATORIAL) {

                if (temExameImagem) {

                    this.showWarningNotification(
                        'Não é permitido adicionar exames laboratoriais em uma mesma solicitação de exames de imagem.'
                    );

                    this.model.exame = null;
                    return;
                }
            }

            exameAtual.novo = !!this.isEdicao;

            if(solicitacoesItens.length === 0) {
                this.examesModal.push(exameAtual);
                this.resetForm();
                return;
            }

            let exameDentroDaValidade = false;

            solicitacoesItens.forEach(item => {
                item.isOrigemExameLaboratorial = !!item.isOrigemExameLaboratorial

                if((item.exameId === exameAtual.id) && (item.dentroDaValidade)) {
                    exameDentroDaValidade = true;

                    this.showConfirmation(
                        `O paciente já possui o procedimento ${item.isOrigemExameLaboratorial ? 'agendado' : 'solicitado'} na data <b>${item.solicitacaoData}</b>, com o status de <b>${item.statusNome}</b>, cuja validade vai até <b>${item.dataValidade}</b>. Deseja continuar?`,
                        async () => this.examesModal.push(exameAtual)
                    )
                }
            })

            if (!exameDentroDaValidade) {
                this.examesModal.push(exameAtual);
            }

            this.resetForm();
        },
        resetForm() {

            this.model.exame = null;

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        destroy(exame) {

            this.examesModal.splice(this.examesModal.indexOf(exame), 1)
        },
    },
    mixins: [repository, error, formats],
    props: {
        examesModal: { type: Array, default: () => [] },
        solicitacoesItens: { type: Array, default: () => [], },
        infraestruturaSolicitanteId: {type: Number, default: null },
        isEdicao: { type: Boolean, default: false },
        reguladorId: {type: Number, default: null },
        sexoPaciente: { type: [String, Number], default: null },
        pacienteId: { type: Number, required: true },
    },
}
</script>